import type { ProspectStatut } from './prospection'

export type CampaignStatus = 'draft' | 'running' | 'paused' | 'completed' | 'cancelled'
export type CampaignProspectStatus = 'queued' | 'sending' | 'sent' | 'failed' | 'excluded' | 'unsubscribed'

export interface CampaignFilters {
  statut?: ProspectStatut | ''
  hasWebsite?: boolean | null
  tag?: string
  search?: string
}

export interface EmailCampaign {
  id: string
  name: string
  status: CampaignStatus
  filters: CampaignFilters
  throttle_per_day: number
  send_window_start: string
  send_window_end: string
  timezone: string
  start_at: string | null
  created_by: string | null
  created_at: string
  started_at: string | null
  completed_at: string | null
  total_count: number
  sent_count: number
  failed_count: number
}

export interface EmailCampaignProspect {
  id: string
  campaign_id: string
  prospect_id: string
  email_to: string
  email_subject: string
  email_body: string
  unsubscribe_token: string
  status: CampaignProspectStatus
  scheduled_at: string | null
  attempts: number
  sent_at: string | null
  resend_message_id: string | null
  error_message: string | null
  created_at: string
}

export const CAMPAIGN_STATUS_LABELS: Record<CampaignStatus, string> = {
  draft: 'Brouillon',
  running: 'En cours',
  paused: 'Pause',
  completed: 'Terminée',
  cancelled: 'Annulée',
}

export const CAMPAIGN_STATUS_COLORS: Record<CampaignStatus, 'gray' | 'mint' | 'gold' | 'blue' | 'red'> = {
  draft: 'gray',
  running: 'mint',
  paused: 'gold',
  completed: 'blue',
  cancelled: 'red',
}

export const CAMPAIGN_PROSPECT_STATUS_LABELS: Record<CampaignProspectStatus, string> = {
  queued: 'En attente',
  sending: 'Envoi…',
  sent: 'Envoyé',
  failed: 'Échec',
  excluded: 'Exclu',
  unsubscribed: 'Désinscrit',
}

export const CAMPAIGN_PROSPECT_STATUS_COLORS: Record<CampaignProspectStatus, 'gray' | 'mint' | 'gold' | 'blue' | 'red'> = {
  queued: 'gray',
  sending: 'gold',
  sent: 'mint',
  failed: 'red',
  excluded: 'gray',
  unsubscribed: 'gray',
}
